import { render } from "./driver-tips.vue?vue&type=template&id=3c87358b&scoped=true"
import script from "./driver-tips.vue?vue&type=script&lang=js"
export * from "./driver-tips.vue?vue&type=script&lang=js"

import "./driver-tips.vue?vue&type=style&index=0&id=3c87358b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c87358b"]])

export default __exports__